import classes from './DisplayStageDeleteCampaign.module.css';
// import StageDelete from './StageDelete'
import '../../css_styles/button_styles.css'
import CampaignTree from '../../current_campaign/campaign_tree_view/CampaignTree';

function DisplayStageDeleteCampaign(props) {

    return (
    <div className = {classes.popup} >
        <div className = {classes.canvas}>
            <h3 style={{margin:'0px', padding:'0px'}}>Campaign Staged for Delete ({props.idxStaged}/{props.numStaged})</h3>
            <p style={{'fontSize': 14, margin:'0px', padding:'0px', paddingTop:'10px' }}><i>Title: </i>{props.titles[0]}</p>
            <p style={{'fontSize': 14, margin:'0px', padding:'0px', paddingTop:'5px', paddingBottom:'10px' }}><i>uuid: </i>{props.toDelete[0].uuid}</p>

            <CampaignTree 
                        height={props.height*0.9*0.95-170}
                        tree={props.toDelete[0]}/>
          <p style={{'fontSize': 16, margin:'0px', color:'var(--aixelo-red)', padding:'0px', paddingTop:'10px', paddingBottom:'10px'}}>
            The displayed objects and data will be permanently deleted. 
          </p>
          <div style={{display: 'flex', alignItems: 'flex-start', gap: '10px'}}>
            <button className={'tableButton'} onClick={props.onDelete}>delete</button>
            <button className={'tableButton'} onClick={props.onCancel}>cancel</button>
          </div>
        </div>
    </div>
    );
}

export default DisplayStageDeleteCampaign